import _ from "lodash";
import React, { useState } from "react";
import Avatar from "react-avatar";
import { IonIcon } from "@ionic/react";
import {
  copyOutline,
  eyeOutline,
  eyeOffOutline,
  refreshOutline,
} from "ionicons/icons";

import styled from "styled-components";
const Container = styled.div`
  background: #ffffff;
  border: 1.81615px solid rgba(146, 146, 146, 0.67);
  box-sizing: border-box;
  border-radius: 21.118px;

  display: flex;
  margin-bottom: 8px;
`;
const EmployeeDetails = styled.div`
  display: flex;
  flex: 3;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-left: 16px;
`;
const EmployeeAvatarContainer = styled.div`
  margin-right: 16px;
`;
const EmployeeAvatar = styled(Avatar)``;
const EmployeeTextDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const EmployeeName = styled.div`
  font-family: Secular One;
  font-size: 1.2em;
`;
const EmployeeTitle = styled.div`
  color: #c4c4c4;
  font-size: 1.2em;
`;
const EmployeePermissions = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: stretch;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-right: 8px;
`;
const EmployeePermissionItem = styled.div`
  border-radius: 20px;
  border: 1.81615px solid rgba(146, 146, 146, 0.67);
  box-sizing: border-box;
  border-radius: 20px;
  font-family: Secular One;
  text-align: center;
  padding: 8px;
  font-size: 0.8em;
  width: 100px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  flex: 1;
  cursor: pointer;

  :hover {
    background: #faf5f5;
  }
`;
const EmployeePermissionItemActivated = styled.div`
  border-radius: 20px;
  border: 1.81615px solid rgba(146, 146, 146, 0.67);
  box-sizing: border-box;
  border-radius: 20px;
  font-family: Secular One;
  text-align: center;
  padding: 8px;
  font-size: 0.8em;
  width: 100px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  flex: 1;
  background: #42d77d;
  color: #ffffff;
  cursor: pointer;

  :hover {
    background: #3ec774;
  }
`;
const EmployeeAuthenticationDetails = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;
const EmployeeAuthUsername = styled.div`
  display: flex;
  justify-content: space-between;
  margin-right: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const EmployeeAuthPassword = styled.div`
  display: flex;
  flex: 1;
  white-space: nowrap;
`;
const EmployeeAuthLabel = styled.div`
  font-family: Secular One;
  font-size: 0.8em;
  margin-right: 8px;
`;
const EmployeeAuthValue = styled.div`
  font-family: Secular One;
  font-size: 0.8em;
  color: #c4c4c4;
  margin-right: 4px;
`;
const EmployeeFunctionality = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 24px;
  flex: 5;
`;
const EmployeeAuthIconButton = styled(IonIcon)`
  margin-right: 4px;
  cursor: pointer;
`;
const EmployeeAuthRenewButton = styled.div`
  font-family: Secular One;
  font-size: 0.8em;
  display: flex;
  justify-content: center;
  color: #07afb5;
  cursor: pointer;

  :hover {
    color: #089ea3;
  }
`;
const EmployeeItemActionButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const EmployeeEditButton = styled.div`
  height: 50%;
  color: #ffffff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
  border-top-right-radius: 18.118px;
  box-shadow: 0 0 0 1px #2eacb4;
  background: #2eacb4;
  padding: 8px;
  cursor: pointer;
  font-family: Secular One;
  :hover {
    background: #2a9ca3;
  }
`;
const EmployeeDeleteButton = styled.div`
  height: 50%;
  color: #ffffff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
  border-bottom-right-radius: 18.118px;
  box-shadow: 0 0 0 1px #f37d7d;
  background: #f37d7d;
  padding: 8px;
  cursor: pointer;
  font-family: Secular One;

  :hover {
    background: #e07575;
  }
`;

const EmployeeAccountItem = (props) => {
  const [productsActive, setProductsActive] = useState(false);
  const [inventoryActive, setInventoryActive] = useState(false);
  const [cogsActive, setCogsActive] = useState(false);
  const [supplierNetworkActive, setSupplierNetworkActive] = useState(false);

  const [passwordVisible, setPasswordVisible] = useState(false);

  const fullName = (
    _.get(props.subAccount, "account_information.last_name") +
    ", " +
    _.get(props.subAccount, "account_information.first_name")
  ).toUpperCase();

  const avatarFullName =
    _.get(props.subAccount, "account_information.first_name") +
    " " +
    _.get(props.subAccount, "account_information.last_name");

  const productsPermissionItem = productsActive ? (
    <EmployeePermissionItemActivated
      onClick={() => {
        setProductsActive(false);
      }}
    >
      PRODUCTS
    </EmployeePermissionItemActivated>
  ) : (
    <EmployeePermissionItem
      onClick={() => {
        setProductsActive(true);
      }}
    >
      PRODUCTS
    </EmployeePermissionItem>
  );

  const inventoryPermissionItem = inventoryActive ? (
    <EmployeePermissionItemActivated
      onClick={() => {
        setInventoryActive(false);
      }}
    >
      INVENTORY
    </EmployeePermissionItemActivated>
  ) : (
    <EmployeePermissionItem
      onClick={() => {
        setInventoryActive(true);
      }}
    >
      INVENTORY
    </EmployeePermissionItem>
  );

  const cogsPermissionItem = cogsActive ? (
    <EmployeePermissionItemActivated
      onClick={() => {
        setCogsActive(false);
      }}
    >
      COGS
    </EmployeePermissionItemActivated>
  ) : (
    <EmployeePermissionItem
      onClick={() => {
        setCogsActive(true);
      }}
    >
      COGS
    </EmployeePermissionItem>
  );

  const supplierNetworkPermissionItem = supplierNetworkActive ? (
    <EmployeePermissionItemActivated
      style={{ fontSize: "0.75em" }}
      onClick={() => {
        setSupplierNetworkActive(false);
      }}
    >
      SUPPLIER NETWORK
    </EmployeePermissionItemActivated>
  ) : (
    <EmployeePermissionItem
      style={{ fontSize: "0.75em" }}
      onClick={() => {
        setSupplierNetworkActive(true);
      }}
    >
      SUPPLIER NETWORK
    </EmployeePermissionItem>
  );

  return (
    <Container>
      <EmployeeDetails>
        <EmployeeAvatarContainer>
          <EmployeeAvatar name={avatarFullName} round={true} />
        </EmployeeAvatarContainer>
        <EmployeeTextDetails>
          <EmployeeName>{fullName}</EmployeeName>
          <EmployeeTitle>
            {_.get(props.subAccount, "organization_title")}
          </EmployeeTitle>
        </EmployeeTextDetails>
      </EmployeeDetails>
      <EmployeeFunctionality>
        <EmployeePermissions>
          {productsPermissionItem}
          {inventoryPermissionItem}
          {cogsPermissionItem}
          {supplierNetworkPermissionItem}
        </EmployeePermissions>
        <EmployeeAuthenticationDetails>
          <EmployeeAuthUsername>
            <EmployeeAuthLabel>USERNAME:</EmployeeAuthLabel>
            <EmployeeAuthValue>
              {_.get(props.subAccount, "username")}
            </EmployeeAuthValue>
            <EmployeeAuthIconButton icon={copyOutline} />
          </EmployeeAuthUsername>
          <EmployeeAuthPassword>
            <EmployeeAuthLabel>PASSWORD:</EmployeeAuthLabel>
            <EmployeeAuthValue>
              {passwordVisible
                ? _.get(props.subAccount, "password")
                : "******************"}
            </EmployeeAuthValue>
            <EmployeeAuthIconButton
              icon={passwordVisible ? eyeOffOutline : eyeOutline}
              onClick={() => {
                setPasswordVisible(!passwordVisible);
              }}
            />
            <EmployeeAuthIconButton icon={copyOutline} />
          </EmployeeAuthPassword>
        </EmployeeAuthenticationDetails>
        <EmployeeAuthRenewButton>
          RENEW EMPLOYEE CREDENTIALS
          <IonIcon icon={refreshOutline} />
        </EmployeeAuthRenewButton>
      </EmployeeFunctionality>
      <EmployeeItemActionButtonContainer>
        <EmployeeEditButton>EDIT</EmployeeEditButton>
        <EmployeeDeleteButton>DELETE</EmployeeDeleteButton>
      </EmployeeItemActionButtonContainer>
    </Container>
  );
};

export default EmployeeAccountItem;
